export const PATIENTS_PATH = '/patients';
export const ORDERS_PATH = '/orders';
export const PRODUCTS_PATH = '/products';
export const EXPLORE_PATH = '/explore';
export const SUPPORT_PATH = '/support';
export const ADMIN_PATH = '/admin';
export const CHECKOUT_PATH = '/checkout';
export const CREDITS_PATH = '/credits';
export const CONFIGURATOR_PATH = '/configurator';
export const PATIENT_DATA_PATH = '/patient-data';
export const MODEL_PATH = '/model';
export const MANUFACTURING_PATH = '/manufacturing';
export const HOME_PATH = '/';
export const COMPANIES_PATH = '/companies';
export const USERS_PATH = '/users';
export const DOCUMENTATION_PATH = '/documentation';
export const NEW_PASSWORD_PATH = '/new-password';
export const RESET_PASSWORD_PATH = '/reset-password';

export const ALIGN_PATH = '/align';
export const ELIMB_PATH = '/elimb';
// Workflow
const WORKFLOW_PATH = '/workflow';

// Patient workflow
const WORKFLOW_PATIENT_PATH = `${WORKFLOW_PATH}/patient`;
export const WORKFLOW_PATIENT_ASSIGN_PATH = `${WORKFLOW_PATIENT_PATH}/assign`;
export const WORKFLOW_PATIENT_CREATE_PATH = `${WORKFLOW_PATIENT_PATH}/create`;

export const START_WORKFLOW_PATH = `${WORKFLOW_PATIENT_ASSIGN_PATH}`;

// Product workflow
export const WORKFLOW_PRODUCT_CATEGORY_PATH = `${WORKFLOW_PATH}/category`;
export const WORKFLOW_PRODUCT_PATH = `${WORKFLOW_PATH}/product`;

// Dataset workflow
const WORKFLOW_DATASET_PATH = `${WORKFLOW_PATH}/dataset`;
export const WORKFLOW_DATASET_ASSIGN_PATH = `${WORKFLOW_DATASET_PATH}/assign`;

// Elimb
export const WORKFLOW_DATASET_ELIMB_PATH = `${WORKFLOW_DATASET_PATH}${ELIMB_PATH}`;
// Scan
const WORKFLOW_DATASET_SCAN_PATH = `${WORKFLOW_DATASET_PATH}/scan`;
export const WORKFLOW_DATASET_ALIGN_SCAN_PATH = `${WORKFLOW_DATASET_SCAN_PATH}${ALIGN_PATH}`;
export const WORKFLOW_DATASET_UPLOAD_SCAN_PATH = `${WORKFLOW_DATASET_SCAN_PATH}/upload`;
// Form
const WORKFLOW_DATASET_FORM_PATH = `${WORKFLOW_DATASET_PATH}/form`;
export const WORKFLOW_DATASET_EDIT_FORM_PATH = `${WORKFLOW_DATASET_FORM_PATH}/edit`;
export const WORKFLOW_DATASET_ASSIGN_FORM_PATH = `${WORKFLOW_DATASET_FORM_PATH}/assign`;

// System
export const DASHBOARD_PATH = '/dashboard';
export const API_PATH = '/api';
export const STATIC_PATH = '/static';
export const THUMBNAIL_PATH = '/thumbnail';
export const ROBOTS_PATH = '/robots.txt';
export const SITEMAP_PATH = '/sitemap.xml';
export const FAVICON_PATH = '/favicon';
export const ANDROID_CHROME_PATH = '/android-chrome';
export const APPLE_TOUCH_ICON_PATH = '/apple-touch-icon';
export const SITE_WEB_MANIFEST_PATH = '/site.webmanifest';

export const SETTINGS_PATH = '/settings';
export const MY_ACCOUNT_PATH = '/my-account';

export const ADD_PATH = '/add';
export const PLATFORM_MANUAL_PATH = `${SUPPORT_PATH}/platform-manual`;
export const ACADEMY_PATH = `${SUPPORT_PATH}/academy`;

//Demo Page
export const DEMO_PATH = '/demo';
export const DEMO_CATEGORY_PATH = `${DEMO_PATH}/category`;
export const DEMO_PAGE_PATH = `${DEMO_PATH}/demo-page`;

//Marketing website

//Insights and webinars
export const INSIGHTS_AND_WEBINARS_PATH = '/insights-and-webinars';
